export default "/images/vendor/@material-design-icons/svg/outlined/play_arrow.svg?9af308fd8257b0af85f29cd82bcbbd63";